import { useSelector } from "react-redux";

import VideoContainer from "./VideoContainer";
import VideoTitle from "./VideoTitle";

const FirstMainContainer=()=>{
    
    //calling the hook once the user is logged in
   
   
    //Now using the information  from the store 
    const movieList=useSelector(store=>store.movie.nowplaying)
    if(!movieList)return;
    const movieForTitle=movieList[1]
    const{id,overview,original_title}=movieForTitle
   
    
    
    
    
    
    
    return(
        <div className="">
            <VideoTitle  overview={overview} title={original_title} />
            <VideoContainer movieId={id}/>
        </div>
    )
}
export default FirstMainContainer;